<template>
  <v-card class="mx-auto" max-width="500">
    <v-sheet class="pa-4 primary lighten-2">
      <v-text-field
        v-model="search"
        label="Search Tensor Spaces"
        dark
        flat
        solo-inverted
        hide-details
        clearable
        clear-icon="mdi-close-circle-outline"
        @input="handleSearch"
      ></v-text-field>
    </v-sheet>
    <v-card-text>
      <v-treeview
        ref="tree"
        :items="tree"
        :search="search"
        :open.sync="open"
        shaped
        activatable
        open-on-click
        hoverable
        selection-type="leaf"
      ></v-treeview>
    </v-card-text>
  </v-card>
</template>

<script>
export default {

  props: {
    pk: String,
  },

  methods: {
    handleSearch(val) {
      if (val) {
        if (!this.allOpened) {
          this.lastOpen = this.open;
          this.allOpened = true;
          this.$refs.tree.updateAll(true);
        }
      } else {
        this.$refs.tree.updateAll(false);
        this.allOpened = false;
        this.open = this.lastOpen;
      }
    },
    getLocalStorageData() {
      const checkPin = (value) => {
        const pin = isNaN(parseInt(value, 10)) ? '' : value;
        localStorage.setItem('pin', pin);
        return pin;
      };

      const allData = {};
      try {
        // TODO Pri3/Sev3: there's a little better implementation elsewhere...
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          const value = localStorage.getItem(key);

          allData[key] = key === 'pin' ? checkPin(value) : value;
        }
      } catch (error) {
        alert(error);
      }

      this.localStorageData = allData;
    },
    checkPk() {
      if (this.pk) {
        const isaPk = () => {
          const regex = /\d{13}-\d*/gm;
          return regex.test(this.pk) || this.pk === '""';
        };

        if (isaPk()) {
          this.setPk();
          this.setPin();

          this.invalidPk = false;
        } else {
          this.invalidPk = true;
        }
      } else {
        if (this.$route.name === 'Home.newPK') {
          this.$pk = null;
          localStorage.removeItem('pk');
          this.$router.push('/');
        }
      }
    },
    setPin() {
      const cachedPin = this.localStorageData.pin;
      const q = this.$route.query;
      console.warn(q.oldPin, q.newPin);

      if (!cachedPin || (cachedPin && cachedPin === q.oldPin)) {
        this.newPin = q.newPin;
        localStorage.setItem('pin', q.newPin);
      } else {
        this.newPin = 'not changed';
      }
    },
    setPk() {
      const hostname = location.hostname;
      const params = new URLSearchParams(location.search);
      this.newPk = true;

      if (this.pk === '""') {
        this.$pk = null;
        localStorage.removeItem('pk');
        if (params.get('backURL')) {
          localStorage.setItem('backURL', params.get('backURL'));
        }
        location.href = location.origin;
      } else {
        this.$pk = this.pk;
        localStorage.setItem('pk', this.pk);
        switch (hostname) {
          case 'sg.tqrtoken.net':
          case 'uk.tqrtoken.net':
          case 'us.tqrtoken.net':
          case 'zz.tqrtoken.net':
          case 'xx.tqrtoken.net':
            if (params.get('backURL')) {
              location.href = 'https://' + params.get('backURL');
            } else {
              location.href = location.origin;
            }
            break;
          default:
            location.href = location.origin;
        }
      }
    },
  },

  data() {
    return {
      localStorageData: {},
      newPk: false,
      newPin: '',
      invalidPk: false,
      open: [],
      search: null,
      caseSensitive: false,
      allOpened: false,
      lastOpen: [],
      tree: [
        {
          id: 1,
          name: 'My Tools :',
          children: [
            { id: 2, name: 'Tasks' },
            { id: 3, name: 'Notes' },
            { id: 4, name: 'Calendar' },
          ],
        },
        {
          id: 5,
          name: 'My Tensors :',
          children: [
            {
              id: 6,
              name: 'TQR Dev :',
              children: [
                { id: 7, name: 'alaina' },
                { id: 8, name: 'jyeh' },
              ],
            },
            {
              id: 9,
              name: 'My Table :',
              children: [{ id: 10, name: 'michaelShea' }],
            },
          ],
        },
        {
          id: 11,
          name: 'Their Tensors :',
          children: [
            {
              id: 12,
              name: 'TQR HQ',
              children: [
                { id: 13, name: 'jasonL' },
                { id: 7, name: 'alaina' },
                { id: 14, name: 'mcorning (You)' },
                { id: 8, name: 'jye' },
              ],
            },
            {
              id: 17,
              name: 'TQR Sales',
              children: [
                { id: 13, name: 'jasonL' },
                { id: 18, name: 'dianne' },
              ],
            },
            {
              id: 19,
              name: 'Boston Z Party',
              children: [
                { id: 7, name: 'alaina' },
                { id: 14, name: 'mcorning (You)' },
              ],
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.getLocalStorageData();
    this.checkPk();

    if (this.redirect) {
      this.$router.push(this.redirect);
    }
    this.overlay = false;
    this.$emit('mountedHome');
  },
};


</script>

<style lang="scss" scoped></style>
